import * as React from 'react';
import cx from 'classnames';

import DropdownCore from '@common/containers/fields/Dropdown';
import { LOOKUP_MODULE_NAME } from '../../LookupTable';

import './Dropdown.styles.scss';

export const Dropdown = (props) => {
  const { value, defaultValue, className, options, index, id, metadata, onSave } = props;
  const normalizedValue = value || defaultValue || '';
  const [savedValue, setSavedValue] = React.useState(value || defaultValue);
  const [currentValue, setCurrentValue] = React.useState(value || defaultValue);

  React.useEffect(() => {
    setSavedValue(normalizedValue);
    setCurrentValue(normalizedValue);
  }, [index, value, id]);

  const handleChange = React.useCallback(async (selectedValue) => {
    try {
      setCurrentValue(selectedValue)

      await onSave({
        index,
        id,
        value: selectedValue,
        metadata,
      });

      setSavedValue(selectedValue);
    } catch (err) {
      setCurrentValue(savedValue);
    }
  }, [currentValue, index, id, savedValue, onSave]);

  return (
    <DropdownCore
      fullWidth
      id={`${LOOKUP_MODULE_NAME}-dropdown--id-${id}--index-${index}`}
      className={cx('LookupTable-Dropdown', className)}
      selectedValue={currentValue || ''}
      searchable={false}
      options={options}
      optionsHeight={200}
      onValueChanged={handleChange}
    />
  );
};

Dropdown.defaultProps = {
  options: [],
};